import type { ComponentProps } from 'react'
import InputLabelListItem from './InputLabelListItem'
import RadioButton from '../Radio/RadioButton'

type InputPropsNames = 'defaultChecked' | 'checked' | 'onChange' | 'name' | 'value'
type InheritedRadioButtonProps = Pick<ComponentProps<typeof RadioButton>, InputPropsNames>
type InheritedInputLabelListItemProps = Omit<ComponentProps<typeof InputLabelListItem>, 'input' | 'ref' | 'onClick' | InputPropsNames>

interface Props extends InheritedInputLabelListItemProps, InheritedRadioButtonProps {
}

function RadioInputListItem({
  defaultChecked,
  checked,
  onChange,
  name,
  value,
  ...rest
}: Props) {
  return <InputLabelListItem
    {...rest}
    input={<RadioButton
      defaultChecked={defaultChecked}
      checked={checked}
      onChange={onChange}
      name={name}
      value={value}
    />}
  />
}

export default RadioInputListItem
